import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

const DatePicker = props => {
  const {
    name,
    title,
    titleStyles,
    selected,
    dateFormat = 'yyyy-MM-dd',
    disabled,
    icon,
    onChange,
    maxDate = null,
    minDate = null,
    showTime = false,
    timeFormat = 'HH:mm',
    timeIntervals = 10,
    styles,
  } = props;

  const selectedDate = selected
    ? selected instanceof Date
      ? selected
      : Date.parse(selected)
    : null;

  const handleChange = value => {
    onChange(name, value);
  };

  return (
    <>
      <div className="datepicker" style={styles}>
        {title && (
          <span className="datepicker__title" style={titleStyles}>
            {title}
          </span>
        )}

        {showTime ? (
          <ReactDatePicker
            selected={selectedDate}
            dateFormat={dateFormat}
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            onChange={handleChange}
            showTimeSelect
            timeFormat={timeFormat}
            timeIntervals={timeIntervals}
          />
        ) : (
          <ReactDatePicker
            selected={selectedDate}
            dateFormat={dateFormat}
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            onChange={handleChange}
          />
        )}

        {icon && (
          <FontAwesomeIcon
            icon={faCalendarAlt}
            color="#f40"
            size="lg"
            className="datepicker__icon"
          />
        )}
      </div>
    </>
  );
};

DatePicker.defaultProps = {
  elements: [],
};

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  icon: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  elements: PropTypes.array,
  dateFormat: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  styles: PropTypes.object,
  titleStyles: PropTypes.object,
};

export default DatePicker;
